/** Constantes globales de la aplicación. */
export const APP = {
  name: 'Refac Admin Panel',
  version: '1.0.0',
} as const;

/** Rutas principales centralizadas para evitar strings mágicos. */
export const ROUTES = {
  login: '/auth/login',
  dashboard: '/dashboard',
  users: '/users',
  sellers: '/sellers',
  catalog: '/catalog',
  payments: '/payments',
  support: '/support',
  ratings: '/ratings',
  banners: '/banners',
  workshops: '/workshops',
  notifications: '/notifications',
  reports: '/reports',
  audit: '/audit',
  settings: '/settings',
} as const;

/** Claves de almacenamiento local. */
export const STORAGE_KEYS = {
  user: 'rap_user',
} as const;

/**
 * App con la que el panel se identifica ante el backend (cabecera
 * `X-App-Platform` y `platform` del login): cada app tiene sus propias cuentas.
 */
export const APP_PLATFORM = 'admin';

/**
 * Roles del backend. Cada app tiene sus propias cuentas: una cuenta tiene UN
 * rol, y el mismo correo puede tener una cuenta por app.
 */
export const ROLE = {
  admin: 0,
  user: 1,
  seller: 2,
} as const;

export const ROLE_LABELS: Record<number, string> = {
  0: 'Administrador',
  1: 'Comprador',
  2: 'Vendedor',
};

/** A qué app pertenece una cuenta de cada rol (texto de ayuda del editor de rol). */
export const ROLE_HINTS: Record<number, string> = {
  0: 'Cuenta de este panel.',
  1: 'Cuenta de la app de compradores.',
  2: 'Cuenta de la app de vendedores.',
};

/** Etiqueta del rol (`roleIds` trae uno solo). */
export function roleLabels(roleIds: readonly number[]): string {
  return roleIds.map((id) => ROLE_LABELS[id]).filter(Boolean).join(', ') || '—';
}
